function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, // reactive,
watch, computed, onMounted, nextTick, getCurrentInstance } from "vue";
import { companyTypeOptions, productTypeOptions, connectTypeOptions, willFeatureOptions, willVideoOptions, teamSizeOptions, mtgCooperationOptions, trialCountryIcon } from "@pt/config/trial";
import { applyTrail } from "@pt/api/user/index";
import LanguageSelector from "@com/components/language-selector/schema.vue";
import InputWithSelector from "@com/components/input-with-select/index.vue";
import { getCountryList } from "@pt/api/common";
import { gmakerTemplateOptions } from "@pt/api/gmaker";
import { language } from "@/common/storage";
import { getProfile } from "@pt/api/user";
import regexp from "@com/utils/regexp.js";
import _ from "lodash";
import animateScrollTo from "animated-scroll-to";
import { PartnerApproveStatus } from "@pt/enums/partner";
import { getSessionStorage, removeSessionStorage } from "@com/utils/storage";
import sendGtag from "@pt/utils/send-gtag.js";
// import { definePropType } from '@types-vue/props'
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var resetFrom = function resetFrom() {
            applyModel.value = _objectSpread({}, _default);
        };
        var elFormErrorScrollIntoView = function elFormErrorScrollIntoView() {
            // 获取第一个校验错误的元素
            var errorElement = document.querySelectorAll(".trial-apply-dialog .is-error")[0];
            // 滚动到错误元素对应位置
            var scroller = document.querySelector(".trial-apply-dialog .el-dialog__body");
            animateScrollTo(errorElement, {
                elementToScroll: scroller
            });
        };
        var handleChange = function handleChange(val) {
            if (val.prop === "region") {
                applyModel.value["region"] = val.value;
            }
            if (val.prop === "contact_type") {
                applyModel.value["contact_type"] = val.value;
            }
            if (val.prop === "contact_account") {
                applyModel.value["contact_account"] = val.value;
            }
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var applyLoading = ref(false);
        var formRef = ref();
        var countryOptions = ref([]);
        var templateOptions = ref([]);
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var userInfo = computed(function() {
            return root.$store.state.user.info;
        });
        var partnerInfo = computed(function() {
            return root.$store.state.user.partnerInfo;
        });
        var disabledCompanyAndRegion = computed(function() {
            return partnerInfo.value.approve_status === PartnerApproveStatus.Approved;
        });
        var trialScope = computed(function() {
            return userInfo.value.trial_scope;
        });
        var innerWillFeatureOptions = computed(function() {
            return willFeatureOptions.map(function(item) {
                return _objectSpreadProps(_objectSpread({}, item), {
                    disabled: (trialScope.value | item.scope) !== trialScope.value
                });
            });
        });
        var applyLayout = [
            {
                rowAttrs: {
                    type: "flex",
                    style: "flex-wrap: wrap;",
                    gutter: 12
                },
                col: [
                    {
                        colAttrs: {
                            span: 12
                        },
                        fields: [
                            "full_name"
                        ]
                    },
                    {
                        colAttrs: {
                            span: 12
                        },
                        fields: [
                            "phone"
                        ]
                    }, 
                ]
            },
            {
                rowAttrs: {
                    type: "flex",
                    style: "flex-wrap: wrap;",
                    gutter: 12
                },
                col: [
                    {
                        colAttrs: {
                            span: 12
                        },
                        fields: [
                            "region"
                        ]
                    },
                    {
                        colAttrs: {
                            span: 12
                        },
                        fields: [
                            "company"
                        ]
                    }, 
                ]
            },
            {
                rowAttrs: {
                    type: "flex",
                    style: "flex-wrap: wrap;",
                    gutter: 12
                },
                col: [
                    {
                        colAttrs: {
                            span: 12
                        },
                        fields: [
                            "company_type"
                        ]
                    },
                    {
                        colAttrs: {
                            span: 12
                        },
                        fields: [
                            "job_title"
                        ]
                    }, 
                ]
            },
            {
                rowAttrs: {
                    type: "flex",
                    style: "flex-wrap: wrap;",
                    gutter: 12
                },
                col: [
                    {
                        colAttrs: {
                            span: 12
                        },
                        fields: [
                            "product_type"
                        ]
                    },
                    {
                        colAttrs: {
                            span: 12
                        },
                        fields: [
                            "app_url"
                        ]
                    }, 
                ]
            },
            {
                rowAttrs: {
                    type: "flex",
                    style: "flex-wrap: wrap;"
                },
                col: [
                    {
                        colAttrs: {
                            span: 24
                        },
                        fields: [
                            "contact_type",
                            "contact_account",
                            "team_size",
                            "isMtg",
                            "m_username",
                            "interested_in",
                            "interesting_gameplay",
                            "interesting_videos",
                            "message", 
                        ]
                    }, 
                ]
            }, 
        ];
        var _default = {
            full_name: "",
            phone: "",
            region: "",
            company: "",
            company_type: "",
            job_title: "",
            product_type: "",
            app_url: "",
            contact_type: language.get().toLowerCase().indexOf("cn") > -1 ? connectTypeOptions[0].value : connectTypeOptions[1].value,
            contact_account: "",
            team_size: "",
            isMtg: "",
            m_username: "",
            interested_in: "",
            interesting_gameplay: [],
            interesting_videos: [],
            message: "",
            email: "",
            referer: ""
        };
        var applyModel = ref(_objectSpread({}, _default));
        var urlValidator = function(rule, value, callback) {
            // 允许url为空
            if (value === "") {
                callback();
            } else if (regexp.url.test(value)) {
                callback();
            } else {
                callback(new Error("".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.urlValidator.errorInfo"))));
            }
        };
        var applySchema = computed(function() {
            return {
                type: "object",
                properties: {
                    full_name: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.full_name.label"),
                        component: "input",
                        field: {
                            placeholder: root.$t("playTurbo.trial.applyTrial.dialog.form.pleaseInput")
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    },
                    phone: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.phone.label"),
                        component: "input",
                        field: {
                            placeholder: root.$t("playTurbo.trial.applyTrial.dialog.form.pleaseInput")
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    },
                    region: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.region.label"),
                        component: LanguageSelector,
                        field: {
                            placeholder: root.$t("playTurbo.trial.applyTrial.dialog.form.pleaseInput"),
                            options: countryOptions.value,
                            disabledSelect: disabledCompanyAndRegion.value
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    },
                    company: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.company.label"),
                        component: "input",
                        field: {
                            placeholder: root.$t("playTurbo.trial.applyTrial.dialog.form.pleaseInput"),
                            disabled: disabledCompanyAndRegion.value
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    },
                    company_type: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.company_type.label"),
                        component: "select",
                        field: {
                            placeholder: "".concat(root.$t("playTurbo.whole.choice")).concat(root.$t("playTurbo.trial.applyTrial.dialog.form.company_type.label")),
                            options: companyTypeOptions
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    },
                    job_title: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.job_title.label"),
                        component: "input",
                        field: {
                            placeholder: root.$t("playTurbo.trial.applyTrial.dialog.form.pleaseInput")
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    },
                    product_type: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.product_type.label"),
                        component: "select",
                        field: {
                            placeholder: "".concat(root.$t("playTurbo.whole.choice")).concat(root.$t("playTurbo.trial.applyTrial.dialog.form.product_type.label")),
                            options: productTypeOptions
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    },
                    app_url: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.app_url.label"),
                        component: "input",
                        field: {
                            placeholder: root.$t("playTurbo.trial.applyTrial.dialog.form.app_url.placeholder")
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            },
                            {
                                validator: urlValidator,
                                trigger: "blur"
                            }, 
                        ]
                    },
                    contact_account: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.contact_account.label"),
                        component: InputWithSelector,
                        field: {
                            selectProp: "contact_type",
                            placeholder: root.$t("playTurbo.trial.applyTrial.dialog.form.pleaseInput"),
                            options: connectTypeOptions
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    },
                    team_size: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.team_size.label"),
                        component: "select",
                        field: {
                            placeholder: "".concat(root.$t("playTurbo.whole.choice")).concat(root.$t("playTurbo.trial.applyTrial.dialog.form.team_size.label")),
                            options: teamSizeOptions
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    },
                    isMtg: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.isMtg.label"),
                        component: "radio-group",
                        field: {
                            class: "custom-option-style",
                            placeholder: root.$t("playTurbo.trial.applyTrial.dialog.form.pleaseInput"),
                            options: mtgCooperationOptions
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    },
                    m_username: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.mtg_name"),
                        component: "input",
                        visible: applyModel.value.isMtg === true,
                        field: {
                            placeholder: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.pleaseInput")).concat(root.$t("Mintegral UserName"))
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    },
                    interested_in: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.interested_in.label"),
                        component: "radio-group",
                        field: {
                            class: "custom-option-style",
                            placeholder: root.$t("playTurbo.trial.applyTrial.dialog.form.pleaseInput"),
                            options: innerWillFeatureOptions.value
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    },
                    interesting_gameplay: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.interesting_gameplay.label"),
                        component: "checkbox-group",
                        visible: [
                            willFeatureOptions[0],
                            willFeatureOptions[2]
                        ].some(function(item) {
                            return item.value === applyModel.value.interested_in;
                        }),
                        field: {
                            class: "custom-option-style",
                            placeholder: root.$t("playTurbo.trial.applyTrial.dialog.form.pleaseInput"),
                            options: templateOptions.value
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.atleast"))
                            }, 
                        ]
                    },
                    interesting_videos: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.interesting_videos.label"),
                        component: "checkbox-group",
                        visible: [
                            willFeatureOptions[1],
                            willFeatureOptions[2]
                        ].some(function(item) {
                            return item.value === applyModel.value.interested_in;
                        }),
                        field: {
                            class: "custom-option-style",
                            placeholder: root.$t("playTurbo.trial.applyTrial.dialog.form.pleaseInput"),
                            options: willVideoOptions
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.atleast"))
                            }, 
                        ]
                    },
                    message: {
                        label: root.$t("playTurbo.trial.applyTrial.dialog.form.message.label"),
                        component: "input",
                        field: {
                            type: "textarea",
                            class: "apply-message",
                            placeholder: root.$t("playTurbo.trial.applyTrial.dialog.form.pleaseInput")
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.trial.applyTrial.dialog.form.empty"))
                            }, 
                        ]
                    }
                }
            };
        });
        var handleClose = function() {
            resetFrom();
            emit("update:visible", false);
        };
        function handleApply() {
            return _handleApply.apply(this, arguments);
        }
        function _handleApply() {
            _handleApply = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var _$ref, postData, refererStorage, _$ref1, email, referer, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            _ctx.next = 4;
                            return (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.validate();
                        case 4:
                            sendGtag({
                                name: "free_trial_submit"
                            });
                            applyLoading.value = true;
                            postData = _objectSpread({}, applyModel.value);
                            if (!postData.isMtg) {
                                delete postData["m_username"];
                            }
                            delete postData["isMtg"];
                            if ((trialScope.value | 1) !== trialScope.value) {
                                delete postData["interesting_gameplay"];
                            }
                            if ((trialScope.value | 2) !== trialScope.value) {
                                delete postData["interesting_videos"];
                            }
                            refererStorage = getSessionStorage("referer");
                            // 从auth页面登陆过来的第三方来源中是否存储了链接中的数据
                            if (refererStorage && JSON.parse(refererStorage) !== "{}") {
                                _$ref1 = JSON.parse(refererStorage), email = _$ref1.email, referer = _$ref1.referer;
                                postData.email = email;
                                postData.referer = referer;
                            }
                            _ctx.next = 15;
                            return applyTrail(postData);
                        case 15:
                            res = _ctx.sent;
                            if (res.data.code === 0) {
                                sendGtag({
                                    name: "free_trial_success"
                                });
                                handleClose();
                                emit("success", {
                                    expired_date: res.data.data.expired_date,
                                    days: res.data.data.days
                                });
                                // 完成试用申请，删除存储数据
                                removeSessionStorage("referer");
                            }
                            _ctx.next = 23;
                            break;
                        case 19:
                            _ctx.prev = 19;
                            _ctx.t0 = _ctx["catch"](0);
                            nextTick(function() {
                                elFormErrorScrollIntoView();
                            });
                            console.log(_ctx.t0);
                        case 23:
                            applyLoading.value = false;
                        case 24:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        19
                    ]
                ]);
            }));
            return _handleApply.apply(this, arguments);
        }
        function getCountryOptions() {
            return _getCountryOptions.apply(this, arguments);
        }
        function _getCountryOptions() {
            _getCountryOptions = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getCountryList();
                        case 2:
                            res = _ctx.sent;
                            countryOptions.value = (_.get(res, "data.data.list") || []).map(function(item) {
                                return {
                                    label: "".concat(trialCountryIcon[item.code.toLowerCase()], " ").concat(item.name, " (").concat(item.code, ")"),
                                    value: item.code
                                };
                            });
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getCountryOptions.apply(this, arguments);
        }
        function getTemplateOptions() {
            return _getTemplateOptions.apply(this, arguments);
        }
        function _getTemplateOptions() {
            _getTemplateOptions = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return gmakerTemplateOptions({
                                option_type: "play_methods"
                            });
                        case 2:
                            res = _ctx.sent;
                            templateOptions.value = (_.get(res, "data.data.list") || []).map(function(item) {
                                return {
                                    label: item.name,
                                    value: item.id
                                };
                            });
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getTemplateOptions.apply(this, arguments);
        }
        function initData() {
            return _initData.apply(this, arguments);
        }
        function _initData() {
            _initData = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res, info;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getProfile();
                        case 2:
                            res = _ctx.sent;
                            info = res.data.data;
                            applyModel.value.full_name = info.name;
                            applyModel.value.region = info.country;
                            applyModel.value.phone = info.cell;
                            if (info.organization) {
                                applyModel.value.company = info.organization;
                            } else if (partnerInfo.value.list.length) {
                                applyModel.value.company = partnerInfo.value.list[0].name;
                            }
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _initData.apply(this, arguments);
        }
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                initData();
            }
            if (!val) {
                resetFrom();
            }
        });
        onMounted(function() {
            getCountryOptions();
            getTemplateOptions();
            initData();
        });
        return {
            formRef: formRef,
            dialogVisible: dialogVisible,
            applyLoading: applyLoading,
            applyLayout: applyLayout,
            applySchema: applySchema,
            applyModel: applyModel,
            handleClose: handleClose,
            handleApply: handleApply,
            handleChange: handleChange
        };
    }
});
